import { thailandTopGspBackgroundImageUrl, thailandTopGspLogoImageUrl } from '@/utils/image-utils';
import React from 'react';

function GameProviderCard({ slug, onClick }: { slug: string; onClick: () => void }) {
  return (
    <div
      className="rounded-xl flex relative shrink-0 hover:cursor-pointer active:scale-[95%] ease-in-out transition-all duration-200"
      onClick={onClick}
    >
      <img
        className="rounded-xl object-contain"
        alt={slug}
        src={thailandTopGspBackgroundImageUrl(slug)}
      />
      <div className="absolute rounded-xl hover:bg-blue-medium/40 ease-in-out transition-all duration-200 inset-0 flex items-end">
        <img
          className="object-contain"
          alt={`${slug} logo`}
          src={thailandTopGspLogoImageUrl(slug)}
        />
      </div>
    </div>
  );
}

export default GameProviderCard;
